import http from '@/utils/ajax'
import { TARIFF_FACTOR_INIT_LOADING, TARIFF_FACTOR_INIT_SUCCESS, TARIFF_FACTOR_INIT_FAIL, TARIFF_FACTOR_COMMIT_KEY } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const state = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  tarfFact: {
    tarfFactId: {
      tarfFactMode: null,
      busCls: null,
      tariff: null,
      benefit: null,
      seqNo: null,
      effDate: null,
      fact1: null,
      fact2: null,
      fact3: null,
      fact4: null,
      fact5: null,
      fact6: null
    }
  }
}

const getters = {

}

const mutations = {
  [TARIFF_FACTOR_INIT_LOADING](state, err) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [TARIFF_FACTOR_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [TARIFF_FACTOR_INIT_FAIL](state, err) {
    state.init = 2
    state.initErr = err
    state.menu = {}
  },
  [TARIFF_FACTOR_COMMIT_KEY](state, data) {
    state.tarfFact.tarfFactId.tarfFactMode = data.tarfFactMode
    state.tarfFact.tarfFactId.busCls = data.busCls
    state.tarfFact.tarfFactId.tariff = data.tariff
    state.tarfFact.tarfFactId.benefit = data.benefit
    state.tarfFact.tarfFactId.seqNo = data.seqNo
    state.tarfFact.tarfFactId.effDate = data.effDate
    state.tarfFact.tarfFactId.fact1 = data.fact1
    state.tarfFact.tarfFactId.fact2 = data.fact2
    state.tarfFact.tarfFactId.fact3 = data.fact3
    state.tarfFact.tarfFactId.fact4 = data.fact4
    state.tarfFact.tarfFactId.fact5 = data.fact5
    state.tarfFact.tarfFactId.fact6 = data.fact6
  }
}

const actions = {
  async tarfFactManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.tarfFactManagementController
    commit(TARIFF_FACTOR_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(TARIFF_FACTOR_INIT_SUCCESS, commitResult)
    } catch (err) {
      commit(TARIFF_FACTOR_INIT_FAIL, extractMessages(err))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
